export default __webpack_public_path__ + "static/media/_DSC0736.c509be3f.JPG";